import styled from "styled-components";

export const CustomReportItemStatus = styled.div`
display: flex;
align-items: center;
gap: 3px;	
// color copied from StatusIndicator overwrite color Blue	
color: var(--color-text-status-inactive-2o9czw, #0972D3);		
`;
